module.exports = __webpack_public_path__ + "static/media/Designer-Ma-Pont-(My-Favourite).8d46f733.png";